import { Link } from 'react-router-dom';
import breadCrumbBg from "../../assets/img/page/breadcrumb.jpg";

const BreadCrumb = ({title, innerTitle}) => {
    return (
        <div className="breadcrumb__area" >
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="breadcrumb__area-content">
                            <h1 style={{ fontSize: '3.5rem' }}>{title}</h1>
                            {/* <ul>
                                <li><Link to="/">Home</Link><i className="fa-regular fa-angle-right"></i></li>
                                <li>{innerTitle}</li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BreadCrumb;